import { render, staticRenderFns } from "./ReportColor.vue?vue&type=template&id=afda03be&"
import script from "./ReportColor.vue?vue&type=script&lang=js&"
export * from "./ReportColor.vue?vue&type=script&lang=js&"
import style0 from "./ReportColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports